import { render, staticRenderFns } from "./GChatBrandListItemContainer.vue?vue&type=template&id=7d0e65f2&"
import script from "./GChatBrandListItemContainer.vue?vue&type=script&lang=ts&"
export * from "./GChatBrandListItemContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports